import classNames from "classnames";
import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import AddPaymentPopup from "../../modals/AddPayment";
import EditDefaultPaymentPopup from "../../modals/EditDefaultPayment";
import ErrorAddingNewPaymentPopup from "../../modals/ErrorAddingNewPayment";
import css from "../../style.scss";
import WalletListItem from "./WalletListItem";
import { useEffect, useState } from "react";
import { selectUserId,selectProfile } from "data/user/selectors";
import { loadWalletList , updatePaymentProfile} from "data/user/actions";
import { selectWalletIsLoading , selectWalletList } from "data/user/selectors";
import { set } from "react-ga";
import { useRef } from "react";

const Wallet = ({
  openAddPaymentPopup,
  openEditDefaultPaymentPopup,
  openErrorAddingNewPaymentPopup,
  openAddPaymentPopupClose,
  openEditDefaultPaymentPopupClose,
  openErrorAddingNewPaymentPopupClose
}) => {


  const userID = useSelector(selectUserId)
  const profile     = useSelector(selectProfile).toJS();
  const updateWallet = useRef(false);
      
  const isLoading = useSelector(selectWalletIsLoading)
  const walletList = useSelector(selectWalletList)
  const [updateCard, setUpdateCard] = useState(false);
  
  const dispatch = useDispatch();


  useEffect(() => {
    if(userID) {
      dispatch(loadWalletList(userID))
    }
    return () => {
      openAddPaymentPopupClose()
      openEditDefaultPaymentPopupClose()
      openErrorAddingNewPaymentPopupClose()
    }
  }, [userID])
  useEffect(() => {
    if(walletList?.length > 0 && updateWallet.current === true ) {
     const defaultWallet =  walletList.find(wallet => wallet.purchasePaymentMethod)
     if (defaultWallet && profile.paymentMethodId !== defaultWallet.paymentMethodId) {
      
      const existsInPaymentMethods = (profile.paymentMethods || []).some(
        (method) => method.id === defaultWallet.paymentMethodId
      );

      if (!existsInPaymentMethods) {
        let cardExpMonth = null;
        let cardExpYear = null;

        if (defaultWallet.cardExp) {
          const [month, year] = defaultWallet.cardExp.split('/');
          cardExpMonth = month;
          cardExpYear = year;
        }

        const formattedWallet = {
          ...defaultWallet,
          id: defaultWallet.paymentMethodId,
          cardExpMonth,
          cardExpYear,
        };
        const alreadyExists = (profile.paymentMethods || []).some(
          (method) => method.id === formattedWallet.id
        );
        if (!alreadyExists) { 
          const updatedPaymentMethods = [
            ...(profile.paymentMethods || []),
            formattedWallet,
          ];
          defaultWallet.paymentMethods = updatedPaymentMethods;
        }
        
      }

      dispatch(updatePaymentProfile(defaultWallet)); // Update profile with defaultWallet
      updateWallet.current = false;
      }
    }
  }, [walletList])

  


  const AddPaymentMethod = value => {
    if (value) {
      openErrorAddingNewPaymentPopup();
    } else {
      openAddPaymentPopup();
      setUpdateCard(true);
      updateWallet.current = true;
    }
  };

  const EditDefaultPaymentMethod = () => {
    openEditDefaultPaymentPopup();
    setUpdateCard(true);
    updateWallet.current = true;
  };
  const walletCustomClose = () => {
    setUpdateCard(true);
    updateWallet.current = true;
  };

  return (
    <>
      {/* Wallet */}
      <div
        className={classNames(
          css.d_flex,
          css.justify_content_center,
          css.pb_20
        )}
      >
        <button
          className={classNames(css.btn_lg, css.clsBtnOrng)}
          onClick={() => AddPaymentMethod()}
        >
          {" "}
          Add New Payment Method
        </button>
        <button
          className={classNames(css.btn_lg, css.clsBtnPrimaryGreen, css.ml_15)}
          onClick={() => EditDefaultPaymentMethod()}
          disabled={walletList?.length === 0}
        >
          {" "}
          Edit Default Payment Settings
        </button>
      </div>
      <div className={css.clsWalletSection}>
        <div
          className={classNames(css.d_flex, css.justify_content_center, "row")}
        >
          <div className="col-lg-10 col-xs-12">
            {walletList && walletList.map((payment, index) => {
              return (
                <WalletListItem
                  key={index}
                  payment={payment}
                  count={walletList?.length}
                  updateWallet={walletCustomClose}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

// export default Wallet
export default connect(null, {
  openAddPaymentPopup: AddPaymentPopup.open,
  openEditDefaultPaymentPopup: EditDefaultPaymentPopup.open,
  openErrorAddingNewPaymentPopup: ErrorAddingNewPaymentPopup.open,
  openAddPaymentPopupClose: AddPaymentPopup.close,
  openEditDefaultPaymentPopupClose: EditDefaultPaymentPopup.close,
  openErrorAddingNewPaymentPopupClose: ErrorAddingNewPaymentPopup.close
})(Wallet);
